import { html, type TemplateResult } from '@design.estate/dees-element';
import type { DeesInputDatepicker } from './component.js';

export const renderDatepicker = (component: DeesInputDatepicker): TemplateResult => {
      return html`
        <div class="input-wrapper">
          <dees-label .label=${component.label} .infoText=${component.infoText} .required=${component.required}></dees-label>
          <div class="input-container">
            <input
              type="text"
              aria-label=${component.label}
              aria-haspopup="dialog"
              aria-expanded=${component.isOpened ? 'true' : 'false'}
              aria-invalid=${component.validationText ? 'true' : 'false'}
              aria-describedby="date-description date-validation"
              class="date-input field-control ${component.isOpened ? 'open' : ''}"
              .value=${component.draftText ?? component.formatDate(component.value)}
              .placeholder=${component.placeholder}
              ?disabled=${component.disabled}
              ?required=${component.required}
              @click=${component.toggleCalendar}
              @keydown=${component.handleKeydown}
              @input=${component.handleManualInput}
              @blur=${component.handleInputBlur}
              style="padding-right: ${component.value || component.draftText ? 'calc(var(--dees-input-action-size) + 40px)' : '40px'}"
            />
            <div class="icon-container">
              ${(component.value || component.draftText) && !component.disabled ? html`
                <button type="button" class="clear-button input-action" @click=${component.clearValue} aria-label="Clear date">
                  <dees-icon icon="lucide:x" iconSize="14"></dees-icon>
                </button>
              ` : ''}
              <dees-icon class="calendar-icon" icon="lucide:calendar" iconSize="16"></dees-icon>
            </div>
          </div>
          <div class="field-messages">
            <div id="date-description">${component.renderDescription()}</div>
            <div id="date-validation" class="validationText" role="status">${component.validationText}</div>
          </div>
        </div>
      `;

};
